import React, { useState } from 'react';
import { toast } from 'sonner';
import { Check, Hash, PackageOpen, Truck } from 'lucide-react';
import { staffAttApi, errMsg, WORK_ROLES } from '@/services/staffAttendanceApi';

const ICONS = { truck_loadman: Truck, unloading_loadman: PackageOpen, piece_rate: Hash };

/** Kiosk: a contract worker ticks one work type at check-in (tap again to untick = regular work). */
export const WorkRolePicker = ({ value, onChange }) => (
  <div className="space-y-2" data-testid="kiosk-work-role">
    <div className="text-lg text-slate-300">Working today as — tick only if it applies</div>
    <div className="grid grid-cols-3 gap-3">
      {Object.entries(WORK_ROLES).map(([k, label]) => {
        const Icon = ICONS[k];
        const on = value === k;
        return (
          <button key={k} type="button" onClick={() => onChange(on ? null : k)} aria-pressed={on}
            className={`relative rounded-2xl border-2 px-3 py-4 text-base font-semibold flex flex-col items-center gap-2 transition-colors ${on ? 'border-amber-400 bg-amber-500/20 text-amber-100' : 'border-slate-600 text-slate-200 hover:border-slate-400'}`}
            data-testid={`kiosk-work-role-${k}`}>
            {on && <Check className="absolute top-2 right-2 w-5 h-5 text-amber-300" data-testid={`kiosk-work-role-${k}-ticked`} />}
            <Icon className="w-7 h-7" />{label}
          </button>
        );
      })}
    </div>
  </div>
);

/** Approval card: supervisor corrects the work type of a contract worker's check-in. */
export const WorkRoleSelect = ({ p }) => {
  const [v, setV] = useState(p.work_role || '');
  const [busy, setBusy] = useState(false);
  const change = async (e) => {
    const nv = e.target.value;
    setBusy(true);
    try {
      await staffAttApi.setWorkRole(p.punch_id, nv || null);
      setV(nv);
      toast.success(`Work type: ${WORK_ROLES[nv] || 'Regular work'}`);
    } catch (err) { toast.error(errMsg(err, 'Could not change work type')); } finally { setBusy(false); }
  };
  return (
    <label className="flex items-center gap-2 text-xs text-gray-600">
      Work type
      <select value={v} onChange={change} disabled={busy} className="h-8 rounded-md border border-gray-300 bg-white px-2 text-sm text-gray-800" data-testid={`punch-work-role-${p.punch_id}`}>
        <option value="">Regular work</option>
        {Object.entries(WORK_ROLES).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
    </label>
  );
};
